
(function(){

  'use strict';

    // **********************************
    //  Data that this directive needs
    // ----------------------------------
    //
    //

  function pxDestinationProfilesDirective(
    $timeout, $filter, toastr, $http, DestinationProfilePagingParams,
    DestinationProfileService, DESTINATION_PROFILES_LIST_FILTERS, $ngBootbox,
    EventServiceEvents, $rootScope
  ) {
    return {
      restrict: 'EA',
      scope: {
        tenant: '=tenant',
        me: '=me'
      },
      templateUrl: 'app/components/settings/destinationProfiles/destinationProfiles.template.html',
      link: function(scope) {


        let scrollEnd = null;
        let containerHeight = null;
        scope.destinationProfilePagingParams = new DestinationProfilePagingParams();
        scope.loadingPage = true;
        scope.totalPages = null;
        scope.searchString = ''
        let originalList = [];
        let pageSet = []
        scope.deleteInProgress = false;

        scope.filtersList = DESTINATION_PROFILES_LIST_FILTERS;
        scope.requestType = 'GET';

        scope.destinationProfilesContainer = null
        scope.checkAllCheckboxes = false
        scope.selectedDestinationProfiles = 0
        scope.nestedContext = null;



        (function() {
          setListeners()
          scrollListener();
        })();

        function resetList () {
          originalList = [];
          scope.destinationProfilesContainer.list = []
          pageSet = []
          angular.element(`#DESTINATION_PROFILES_SCROLL_CONTAINER`).scrollTop(0)
        }


        function getFirstPage () {
          scope.loadingPage = true
          scope.destinationProfilePagingParams.pagingCriteria.page = 0;
          DestinationProfileService.getList(null,scope.destinationProfilePagingParams).then(function(response) {
            if (scope.destinationProfilesContainer) {
              resetList()
            }
            pageSet.push(response)
            scope.totalPages = response.page.totalPages;
            originalList = angular.copy(response.list)
            scope.destinationProfilesContainer = response
            scope.loadingPage = false
          }).catch(function(error) {
            scope.loadingPage = false
            console.log(error);
          })
        }


        scope.getFirstPage = function() {
          getFirstPage()
        }

        scope.search = function () {
          scope.destinationProfilePagingParams.pagingCriteria.match = scope.searchString
          resetList()
          getFirstPage()
        }

        scope.reloadList = function () {
          getFirstPage()
        }

        function getNextPage () {
          if (!scope.loadingPage && scope.totalPages > scope.destinationProfilePagingParams.pagingCriteria.page + 1) {
            scope.loadingPage = true;
            scope.destinationProfilePagingParams.pagingCriteria.page += 1;
            DestinationProfileService.getList(null,scope.destinationProfilePagingParams).then((response) => {
              if (response.list) {
                pageSet.push(response)
                originalList = originalList.concat(angular.copy(response.list));
                scope.destinationProfilesContainer.list = scope.destinationProfilesContainer.list.concat(response.list);
              }
              scope.loadingPage = false;
              }).catch((error) => {
                console.log('** error : ', error);
              })
          }
        }

        function updateList () {
          scope.loadingPage = true;
          const tempPageSize = (pageSet[pageSet.length - 1].page.number + 1) * 20;
          scope.destinationProfilePagingParams.pagingCriteria.pageSize = tempPageSize;
          scope.destinationProfilePagingParams.pagingCriteria.page = 0;
          DestinationProfileService.getList(null, scope.destinationProfilePagingParams).then((response) => {
            scope.destinationProfilePagingParams.pagingCriteria.pageSize = 20;
            scope.destinationProfilePagingParams.pagingCriteria.page = (pageSet[pageSet.length - 1].page.number + 1).page;
            scope.destinationProfilesContainer.list = response.list;
            scope.loadingPage = false;
          }).catch((error) => {
            console.log('** error : ', error);
          })
        }

        function getDestinationProfile (destinationProfileId) {
          DestinationProfileService.getProfileById(destinationProfileId).then((updatedDestinationProfile) => {
            const index = scope.destinationProfilesContainer.list.findIndex(destinationProfile => { return destinationProfile.info.profileId === destinationProfileId })
            scope.destinationProfilesContainer.list[index] = updatedDestinationProfile
          }).catch((error) => {
            console.log('** error : ', error);
          })
        }




        scope.selectAllItems = function() {
          angular.forEach(scope.destinationProfilesContainer.list, function(value) {
            value.options.isSelected = scope.checkAllCheckboxes;
          });
        };

        scope.$watch(function() {
          if (scope.destinationProfilesContainer) {
            return scope.destinationProfilesContainer.list;
          }
        }, function() {
          if (scope.destinationProfilesContainer) {
            scope.selectedDestinationProfiles = scope.destinationProfilesContainer.list.findAllElements({

              options: {
                isSelected: true
              }
            }).length;
            if (!scope.selectedDestinationProfiles) {
              scope.checkAllCheckboxes = false;
            } else {
              scope.checkAllCheckboxes = (scope.selectedDestinationProfiles === scope.destinationProfilesContainer.list.length);
            }
          }
        }, true);



        scope.deleteDestinationProfiles = function (destinationProfile) {
          const selectedDestinationProfiles = destinationProfile ? [destinationProfile] : scope.destinationProfilesContainer.list.findAllElements({options:{isSelected:true}})
          let warning = ''

          if (selectedDestinationProfiles.length === 1) {
            warning = $filter("stringular")($filter("translate")("DeleteDestinationProfile"), selectedDestinationProfiles[0].info.name);
          } else {
            warning = $filter("stringular")($filter("translate")("DeleteDestinationProfiles"), selectedDestinationProfiles.length);
          }

          $ngBootbox.confirm(warning).then(function() {
            scope.deleteInProgress = true;
            DestinationProfileService.deleteProfiles(selectedDestinationProfiles).then(function(response) {
              let toast = "";
              if (selectedDestinationProfiles.length === 1) {
                toast = $filter("stringular")($filter("translate")("DestinationProfileDeleted"), selectedDestinationProfiles[0].info.name);
              } else {
                toast = $filter("stringular")($filter("translate")("DestinationProfilesDeleted"), selectedDestinationProfiles.length);
              }
              toastr.success(toast);
            }).catch(function(error) {
              if (error.data.statusCode === 409) {
                handleError(error)
              }
            })
          }).catch(function(error) {})
        }

        function handleError (error) {
          switch (error.data.errorCode) {
            case "CONFLICT":
              error.data.parameters[0] = scope.destinationProfilesContainer.list.find(destinationProfile => destinationProfile.info.profileId === error.data.parameters[0]).info.name ?? error.data.parameters[0]
              error.data.manualLink = 'https://docshield.tungstenautomation.com/Printix/en_US/help/admin/Printix_admin/t_capture_destination_profiles.html'
            break;
            default:

            break
          }

          $rootScope.$broadcast('REQUEST_ERROR_HELP', {error: error})
        }



        scope.deleteDestinationProfile = function (destinationProfile) {
          scope.deleteDestinationProfiles(destinationProfile)
        }

        scope.openListMenu = function (event, destinationProfile) {
          scope.closeAllMenus()
          var position = document.getElementById(event.target.id).getBoundingClientRect();
          setTimeout(function () {
            scope.closeListMenu();
            scope.listMenuContext = destinationProfile;
            scope.listMeta = {
              position: {left: position.x, top: position.y},
              parentId: event.target.id,
              type: 'destinationProfileList',
              scrollContainerId: 'DESTINATION_PROFILES_SCROLL_CONTAINER'
            }
            scope.$apply();
          }, 50)
        }


        scope.closeAllMenus = function () {
          scope.menuContent = null;
          scope.menuSpecs = null;
          scope.selectedContextMenuItem = null;
          scope.contextContent = null;
        }

        scope.closeListMenu = function (destinationProfile, action) {
          scope.listMenuContext = null;
          scope.listMeta = null;

          switch (action) {
            case 'DELETE_DESTINATION_PROFILE':
              scope.deleteDestinationProfile(destinationProfile);
            break;
          }
        }

        scope.openContext = function (event, context, menuOption) {
          scope.closeAllMenus()
          $timeout(function  () {
            scope.selectedContextMenuItem  =  menuOption;
            scope.contextContent = context;
            scope.nestedContext = context;
            scope.auxiliaries = {
              tenant: scope.tenant,
              me: scope.me,
            };
          }, 50)
        }


        function scrollListener () {
          var scrollLeft = 0;
          var scrollTop = 0;
          angular.element('#DESTINATION_PROFILES_SCROLL_CONTAINER').on('scroll', function (event) {
            if (event.currentTarget.scrollLeft !== scrollLeft) {
              scope.scrollingLEFT = true;
              scrollLeft = event.currentTarget.scrollLeft;
              scope.$apply();
            } else {
              scope.scrollingLEFT = false
            }

            if (scope.scrollingLEFT) {
              $timeout(() => {
                scope.scrollingLEFT = false;
              }, 1500)
            }

            scrollEnd = event.currentTarget.clientHeight + event.currentTarget.scrollTop + 30;
            containerHeight = event.currentTarget.scrollHeight;

            if (!scope.loadingPage && scope.totalPages > scope.destinationProfilePagingParams.pagingCriteria.page + 1) {
              if (scrollEnd > containerHeight) {
                $timeout(function() {
                  getNextPage();
                }, 300)
              }
            }
          });
        }

        function setListeners() {

          scope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_ADMINS.EVENTS.DESTINATION_PROFILE_CREATED, function (name, data) {
            if (pageSet.length <= 1) {
              getFirstPage()
            } else {
              updateList()
            }
          });

          scope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_ADMINS.EVENTS.DESTINATION_PROFILE_DELETED, function (name, data) {
            if (pageSet.length <= 1) {
              getFirstPage()
            } else {
              updateList()
            }
          });

          scope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_ADMINS.EVENTS.DESTINATION_PROFILE_UPDATED, function (name, data) {
            const destinationProfileId = data.destinationProfile.split('/').pop();
            if (scope.destinationProfilesContainer && scope.destinationProfilesContainer.list) {
              if (scope.destinationProfilesContainer.list.find(item => item.info.profileId === destinationProfileId)) {
                getDestinationProfile(destinationProfileId)
              }
            }
          });
        }

        ////////////////////////////////////////////
        ////////////////////////////////////////////
        // TOOLTIP STUFF
        ////////////////////////////////////////////
        scope.showTooltip = function (showTip, position, type, context) {
          if (showTip) {
            tooltip(position, type, context)
          } else {
            scope.clearTooltip();
          }
        }


        function tooltip (position, type, context) {
          scope.clearTooltip();
          scope.tooltipContent = {
            title: type.charAt(0).toUpperCase() + type.slice(1),
            type: type,
            context: context,
          }
          scope.tooltipObject = {
            position: {left: position.startX, top: position.startY + 20}
          }
        }

        scope.clearTooltip = function () {
          scope.tooltipContent = null;
          scope.tooltipObject = null;
        }

        scope.$on('$destroy', function() {
          angular.element('#DESTINATION_PROFILES_SCROLL_CONTAINER').off('scroll', function(){});
        })

      }
    };
  }

  pxDestinationProfilesDirective.$inject = [
    '$timeout', '$filter', 'toastr', '$http', 'DestinationProfilePagingParams',
    'DestinationProfileService', 'DESTINATION_PROFILES_LIST_FILTERS', '$ngBootbox',
    'EventServiceEvents', '$rootScope'
  ];

  angular
    .module('printix-admin')
    .directive('pxDestinationProfilesDirective', pxDestinationProfilesDirective)
    .constant("DESTINATION_PROFILES_LIST_FILTERS", [
      {
        name: 'Type',
        parameter: 'types',
        type: 'checkbox',
        values: [
          {
            key: 'OneDriveForBusiness',
            value: 'OneDrive',
            type: 'checkbox'
          },
          {
            key: 'SharePoint',
            value: 'SharePoint',
            type: 'checkbox'
          },
          {
            key: 'Connector',
            value: 'Connector',
            type: 'checkbox'
          }
        ]
      }
    ]);

})();
